
  import { AccountModule, AccountStore } from '@/store/account';
  import { Options, Vue } from 'vue-class-component';
  import { nextTick } from 'vue';
  import { NavigationModule, NavigationStore } from '@/store/navigation';
  import NavigationMenuItem from '@/types/NavigationMenuItem';
  import Routes from '@/types/Routes';
  import AppEvents from '@/types/AppEvents';
  import useEventsBus from '@/utils/eventBus';

  @Options({})
  export default class Header extends Vue {
    private accountStore: AccountModule = AccountStore;
    private navigationStore: NavigationModule = NavigationStore;

    active = 'nav-item-active';
    SUPPORT_LOCALES = ['en'];
    isMobileNavOpen = false;

    get user() {
      return this.accountStore.authData;
    }

    get userData() {
      const _user = this.accountStore.allAccounts.find((t) => t.id === !!this.accountStore.userData.id);

      return _user || this.accountStore.userData;
    }

    get firstName() {
      return this.userData.name;
    }

    get lastNameWithCompany() {
      const _user = this.userData;

      const company = _user.company ? ` (${_user.company})` : '';

      return `${_user.surname}${company}`;
    }

    get menuItems() {
      return this.navigationStore.menu.items;
    }

    get subMenuItems() {
      return this.navigationStore.activeMenuItem.NavigationMenuItem;
    }

    async logout() {
      await this.accountStore.logout();
      this.navigationStore.resetMenuAction();
      this.isMobileNavOpen = false;

      this.$forceUpdate();
      this.$router.push({ name: 'root' });
    }

    async mounted() {
      await this.loadLocaleMessages(this.SUPPORT_LOCALES[0]);

      if (this.user.token) {
        const params = {
          isAdmin: this.accountStore.isAdmin,
          route: this.$route.name
        };

        this.navigationStore.initMenuAction(params);
      }
    }

    processMenuItemClick(menuItem: NavigationMenuItem) {
      this.navigationStore.updateMenuItem(menuItem);
      this.processRouteChange(menuItem);
      this.isMobileNavOpen = false;
    }

    processRouteChange(menuItem) {
      const activeMenu = this.navigationStore.activeMenuItem;

      const qParams = this.$route.query;
      if (
        menuItem.routeName === Routes.management.accounts.name ||
        menuItem.routeName === Routes.management.licenses.name ||
        menuItem.routeName === Routes.management.activations.name
      ) {
        this.$router.push({ name: activeMenu.activeRoute, query: qParams });
      } else {
        this.$router.push({ name: activeMenu.activeRoute });
      }
    }

    async doTools() {
      await this.accountStore.doWork();
    }

    processModifyAccount() {
      this.isMobileNavOpen = false;

      if (this.$route.name === `${Routes.management.name}|${Routes.management.accounts.name}`) {
        const { emit } = useEventsBus();
        emit(AppEvents.ModifyCurrentUserAcc);
      } else {
        this.accountStore.setModifyAccountMode(true);
        this.$router.push(Routes.management.accounts.path);
      }
    }

    toggleMobileNav() {
      this.isMobileNavOpen = !this.isMobileNavOpen;
    }

    async loadLocaleMessages(locale: any) {
      const messages = await import(`@/assets/i18n/${locale}.json`);

      // set locale and locale message
      const i18n: any = this.$i18n;
      i18n.setLocaleMessage(locale, messages.default);

      return nextTick();
    }
  }
